/* Hoptimaal statiegeld (15 okt 2026, vervangt Magic Fees). Na elke wijziging aan de winkelwagen zet dit
   script de regels van het verborgen product "statiegeld" (0% btw) gelijk aan wat de bieren nodig hebben.
   Hoeveel er nodig is rekent de server uit: sections/hop-statiegeld-data.liquid (Section Rendering API).
   De controle bij het afrekenen (Shopify Function) vangt af wat hier toch misgaat.
   Bron: vat33/shopify-theme/hoptimaal/assets/hop-statiegeld.js */
(function () {
  if (window.__hopStatiegeld) return;
  window.__hopStatiegeld = true;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var origFetch = window.fetch.bind(window);
  var bezig = null, eigen = false;

  function lees() {
    return origFetch(root + 'cart?sections=hop-statiegeld-data', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var d = document.createElement('div');
        d.innerHTML = j['hop-statiegeld-data'] || '';
        var s = d.querySelector('[data-hop-statiegeld]');
        return s ? JSON.parse(s.textContent) : null;
      });
  }

  // Resultaat: true als er iets is aangepast.
  function sync() {
    if (bezig) return bezig.then(sync);
    bezig = lees().then(function (d) {
      if (!d || !d.product) return false;
      var upd = {}, verschil = false;
      Object.keys(d.nodig).forEach(function (v) {
        if (!v) return;
        if ((d.huidig[v] || 0) !== d.nodig[v]) { upd[v] = d.nodig[v]; verschil = true; }
      });
      // Achtergebleven Magic Fees-attributen (__fees, uit winkelwagens van vóór 15 okt 2026) opruimen
      var attr = d.mf ? { __fees: '', __fees_sales_channel: '' } : null;
      if (!verschil && !attr) return false;
      eigen = true;
      var body = verschil ? { updates: upd } : {};
      if (attr) body.attributes = attr;
      return origFetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function () { return verschil; });
    }).catch(function () { return false; }).then(function (r) { eigen = false; bezig = null; return r; });
    return bezig;
  }

  function isWijziging(url, init) {
    var m = (init && init.method ? String(init.method) : 'GET').toUpperCase();
    return m === 'POST' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (eigen || !isWijziging(url, init)) return p;
    return p.then(function (res) {
      if (!res.ok) return res;
      return sync().then(function (veranderd) {
        // change/update geven de hele winkelwagen terug: dan de verse versie (mét statiegeld) doorgeven
        if (veranderd && /\/cart\/(change|update)/.test(url)) {
          return origFetch(root + 'cart.js', { credentials: 'same-origin' });
        }
        return res;
      });
    });
  };

  function start() {
    sync().then(function (veranderd) {
      if (veranderd && /\/cart\/?$/.test(location.pathname)) location.reload();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
